export const Master = {
  categories: [
    {
      id: '1',
      name: 'Food & Beverage',
      slug: 'food-beverage',
    },
    {
      id: '2',
      name: 'Home Appliance',
      slug: 'home-appliance',
    },
    {
      id: '3',
      name: 'Groceries',
      slug: 'groceries',
    },
    {
      id: '4',
      name: 'Fashion',
      slug: 'fashion',
    },
    {
      id: '5',
      name: 'Beauty',
      slug: 'beauty',
    },
    {
      id: '6',
      name: 'Hotel & Dining',
      slug: 'hotel-dining',
    },
    {
      id: '7',
      name: 'Reward BCA',
      slug: 'reward-bca',
    },
    {
      id: '8',
      name: 'e-Commerce',
      slug: 'e-commerce',
    },
  ],
  cities: [
    {
      id: '1',
      name: 'Nasional',
      slug: 'nasional',
    },
    {
      id: '2',
      name: 'Jabodetabek',
      slug: 'jabodetabek',
    },
    {
      id: '3',
      name: 'Bandung',
      slug: 'bandung',
    },
    {
      id: '4',
      name: 'Medan',
      slug: 'medan',
    },
    {
      id: '5',
      name: 'Surabaya',
      slug: 'surabaya',
    },
    {
      id: '6',
      name: 'Bali',
      slug: 'bali',
    },
    {
      id: '7',
      name: 'Semarang',
      slug: 'semarang',
    },
    {
      id: '8',
      name: 'Palembang',
      slug: 'palembang',
    },
    {
      id: '9',
      name: 'Yogyakarta',
      slug: 'yogyakarta',
    },
    {
      id: '10',
      name: 'Batam',
      slug: 'batam',
    },
    {
      id: '11',
      name: 'Makassar',
      slug: 'makassar',
    },
  ],
  promo: {
    id: [
      {
        id: '1',
        title: 'Yogya Group Bandung - Free Voucher Rp 100.000',
        category: 'Groceries',
        city: 'Bandung',
        periode: 'Hingga 24 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/yogya-group',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/yogya-group-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/yogya-group-logo',
      },
      {
        id: '2',
        title: 'JC SUPERMARKET BCS Batam - Dapatkan Voucher Rp 50.000',
        category: 'Groceries',
        city: 'Batam',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/jc-supermarket-bcs',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jc-supermarket-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jc-supermarket-logo',
      },
      {
        id: '3',
        title: 'JM Group Palembang - Dapatkan Hadiah Langsung Minyak Goreng 2 Liter',
        category: 'Groceries',
        city: 'Palembang',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/jm-group',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jm-group-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jm-group-logo',
      },
      {
        id: '4',
        title: 'Brastagi Supermarket Medan - Dapatkan 1 Pack Jeruk',
        category: 'Groceries',
        city: 'Medan',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/brastagi-supermarket',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/brastagi-supermarket-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/brastagi-supermarket-logo',
      },
      {
        id: '5',
        title: 'Rezeki Supermarket - Free Voucher Rp 25.000',
        category: 'Groceries',
        city: 'Jabodetabek',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/rezeki-supermarket',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/rezeki-supermarket-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/rezeki-supermarket-logo',
      },
      {
        id: '6',
        title: 'Market City - Free Voucher Rp 25.000',
        category: 'Groceries',
        city: 'Jabodetabek',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/market-city',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/market-city-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/market-city-logo',
      },
      {
        id: '7',
        title: 'GS Retail - Dapatkan Free Product',
        category: 'Groceries',
        city: 'Jabodetabek',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/gs-retail',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/retail-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/retail-logo',
      },
      {
        id: '8',
        title: 'Papaya Fresh Gallery Bali - Dapatkan Voucher Rp 50.000',
        category: 'Groceries',
        city: 'Bali',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/papaya-fresh-gallery',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pepaya-fresh-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pepaya-fresh-logo',
      },
      {
        id: '9',
        title: 'Istana Buah Semarang - Hadiah Beras Organik',
        category: 'Groceries',
        city: 'Semarang',
        periode: 'Hingga 16 Juni 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/istana-buah',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/istana-buah-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/istana-buah-logo',
      },
      {
        id: '10',
        title: 'Ranch Market - Dapatkan Voucher hingga Rp 150.000',
        category: 'Groceries',
        city: 'Nasional',
        periode: 'Hingga 16 Juni 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/ranch-market',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ranch-market-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ranch-market-logo',
      },
      {
        id: '11',
        title: 'The Foodhall - Dapatkan Voucher hingga Rp 100.000',
        category: 'Groceries',
        city: 'Nasional',
        periode: 'Hingga 31 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/foodhall',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/foodhall-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/foodhall-logo',
      },
      {
        id: '12',
        title: 'All Fresh - Redeem Reward BCA Rp 88.000, Gratis Jeruk 1 Pack',
        category: 'Reward BCA',
        city: 'Nasional',
        periode: 'Hingga 23 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/all-fresh',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/allfresh-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/allfresh-logo',
      },
      {
        id: '13',
        title: 'Ranch Market Group - Redeem Reward BCA Rp 88.000, Gratis Jeruk 1 Pack',
        category: 'Reward BCA',
        city: 'Nasional',
        periode: 'Hingga 23 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/ranch-market',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ranch-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ranch-logo',
      },
      {
        id: '14',
        title: 'The FoodHall & Daily FoodHall - Redeem Reward BCA Rp 88.000, Gratis Jeruk 1 Pack',
        category: 'Reward BCA',
        city: 'Nasional',
        periode: 'Hingga 23 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/the-foodhall',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/foodhall-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/foodhall-logo',
      },
      {
        id: '15',
        title: '5th Avenue Semarang - Dapatkan Cake',
        category: 'Food & Beverage',
        city: 'Semarang',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/5th-avenue',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/avenue-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/avenue-logo',
      },
      {
        id: '16',
        title: 'Angke Restaurant - Potongan harga Rp 288.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/angke-restaurant',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/angke-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/angke-logo',
      },
      {
        id: '17',
        title: 'Bali Sentosa Seafood - Potongan Langsung Rp 88.000',
        category: 'Food & Beverage',
        city: 'Kuta',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/bali-sentosa-seafood',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sentosa-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sentosa-logo',
      },
      {
        id: '18',
        title: 'Ban Ban - Diskon 25%',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 10 April 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/ban-ban',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/banban-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/banban-logo',
      },
      {
        id: '19',
        title: 'Chopstix - Potongan Rp 20.000',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 10 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/chopstix',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chopstix-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chopstix-logo',
      },
      {
        id: '20',
        title: 'DIMSUM INS Solo - Dapatkan Ekstra Dimsum',
        category: 'Food & Beverage',
        city: 'Solo',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/dimsum-ins',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dimsum-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dimsum-logo',
      },
      {
        id: '21',
        title: 'Dragon Hot Pot - Dapatkan Potongan Rp 50.000 & Liang Teh/ Grass Jelly',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/dragon-hot-pot',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dragon-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dragon-logo',
      },
      {
        id: '22',
        title: 'Duck King - Potongan Hingga Rp 1 Juta',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/duck-king',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/duckking-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/duckking-logo',
      },
      {
        id: '23',
        title: 'Gong cha - Lucky Dip',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/gong-cha',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/gongcha-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/gongcha-logo',
      },
      {
        id: '24',
        title: 'Han Palace Surabaya - Potongan Rp 200.000',
        category: 'Food & Beverage',
        city: 'Surabaya',
        periode: 'Hingga 20 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/han-palace',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/han-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/han-logo',
      },
      {
        id: '25',
        title: 'Ikkudo - Potongan Rp 20.000',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 31 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/ikkudo',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ikkudo-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ikkudo-logo',
      },
      {
        id: '26',
        title: 'Jumbo Restoran Medan - Diskon 50% Menu Pilihan',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/jumbo-restoran',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jsr-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jsr-logo',
      },
      {
        id: '27',
        title: 'Kwetiau Aho 88 - Potongan Rp 10.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/kwetiau-aho-88',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/kwetiau-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/kwetiau-logo',
      },
      {
        id: '28',
        title: 'May Star Surabaya - Potongan Hingga Rp 1.188.000',
        category: 'Food & Beverage',
        city: 'Surabaya',
        periode: 'Hingga 31 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/may-star',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/avenue-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/avenue-logo',
      },
      {
        id: '29',
        title: 'New Fajar Restaurant Surabaya - Potongan Harga Rp 200.000',
        category: 'Food & Beverage',
        city: 'Surabaya',
        periode: 'Hingga 20 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/new-fajar-restaurant',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/fajar-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/fajar-logo',
      },
      {
        id: '30',
        title: 'Ocean 8 - Potongan Rp 288.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/ocean-8',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ocean-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ocean-logo',
      },
      {
        id: '31',
        title: 'Paradise Dynasty - Potongan Rp 288.000',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/paradise-dynasty',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dynasty-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dynasty-logo',
      },
      {
        id: '32',
        title: 'Pilastro Signature Medan - Dapatkan Kertas Angpao',
        category: 'Food & Beverage',
        city: 'Medan',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/pilastro-signature',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pilastro-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pilastro-logo',
      },
      {
        id: '33',
        title: 'Raa Cha - Potongan Rp 20.000',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 10 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/raa-cha',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/reacha-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/reacha-logo',
      },
      {
        id: '34',
        title: 'RM Hongkong Makassar - Diskon 20%',
        category: 'Food & Beverage',
        city: 'Makassar',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/rm-hongkong',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hongkong-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hongkong-logo',
      },
      {
        id: '35',
        title: 'Royal Dynasty Restaurant Bandung - Cashback Rp 100.000',
        category: 'Food & Beverage',
        city: 'Bandung',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/royal-dynasty-restaurant',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/royal-dynasty-1-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/royal-dynasty-1-logo',
      },
      {
        id: '36',
        title: 'Royal Resto Group Surabaya - Potongan Hingga Rp 200.000',
        category: 'Food & Beverage',
        city: 'Surabaya',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/royal-resto-group',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/royal-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/royal-logo',
      },
      {
        id: '37',
        title: 'Sari Laut Musi Palembang - Potongan Rp 100.000',
        category: 'Food & Beverage',
        city: 'Palembang',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/sari-laut-musi',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/slm-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/slm-logo',
      },
      {
        id: '38',
        title: 'Shu Guo Yin Xiang Bandung - Potongan Rp 150.000',
        category: 'Food & Beverage',
        city: 'Bandung',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/shu-guo-yin-xiang',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sgyx-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sgyx-logo',
      },
      {
        id: '39',
        title: 'The Grill Estate Batam - Diskon 20%',
        category: 'Food & Beverage',
        city: 'Batam',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/the-grill-estate',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/grill-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/grill-logo',
      },
      {
        id: '40',
        title: 'The Leaf BSD - Potongan Hingga Rp 1 Juta',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/the-leaf-bsd',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/leaf-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/leaf-logo',
      },
      {
        id: '41',
        title: 'Warung Laota Makassar - Diskon 20%',
        category: 'Food & Beverage',
        city: 'Makassar',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/warung-laota',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/laota-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/laota-logo',
      },
      {
        id: '42',
        title: 'Wee Nam Kee - Harga Spesial Paket Makan',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/wee-nam-kee',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/wnk-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/wnk-logo',
      },
      {
        id: '43',
        title: 'Wong Fu Kie - Potongan Hingga 288.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/wong-fu-kie',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/wfk-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/wfk-logo',
      },
      {
        id: '44',
        title: 'H&M - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/hnm',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hnm-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hnm-logo',
      },
      {
        id: '45',
        title: 'Hush Puppies - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/hush-puppies',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hush-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hush-logo',
      },
      {
        id: '46',
        title: 'Obermain - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/obermain',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/obermain-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/obermain-logo',
      },
      {
        id: '47',
        title: 'CAT - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/cat',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/cat-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/cat-logo',
      },
      {
        id: '48',
        title: 'Playboy/ 101 Shoes - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/playboy',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/playboy-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/playboy-logo',
      },
      {
        id: '49',
        title: 'Le Sportsac - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/le-sportsac',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/lesport-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/lesport-logo',
      },
      {
        id: '50',
        title: 'Central Dept. Store - Dapatkan Voucher Shopping Rp 100 Ribu dan Grand Prize Voucher Rp 888 Ribu',
        category: 'Fashion',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/central-dept-store',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/central-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/central-logo',
      },
      {
        id: '51',
        title: 'This is April - Diskon 10%',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/this-is-april',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/april-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/april-logo',
      },
      {
        id: '52',
        title: 'Urban Icon - Potongan Rp 188 Ribu',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/urban-icon',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/urban-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/urban-logo',
      },
      {
        id: '53',
        title: 'Fossil - Potongan Rp 288.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/fossil',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/fossil-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/fossil-logo',
      },
      {
        id: '54',
        title: 'The Arista Hotel Palembang - Diskon 20%',
        category: 'Hotel & Dining',
        city: 'Palembang',
        periode: 'Hingga 21 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/the-arista-hotel',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/arista-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/arista-logo',
      },
      {
        id: '55',
        title: 'Ching San Restaurant (Melia Purosani Hotel Yogyakarta) - Buy 10 Get 1 Free',
        category: 'Hotel & Dining',
        city: 'Yogyakarta',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/ching-san-restaurant-melia-purosani-hotel',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chingsan-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chingsan-logo',
      },
      {
        id: '56',
        title: 'Swissotel Jakarta PIK Avenue - Diskon 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/swissotel-jakarta-pik-avenue',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/swiss-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/swiss-logo',
      },
      {
        id: '57',
        title: 'JW Marriott Jakarta - Hemat 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/jw-marriott-jakarta',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jw-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jw-logo',
      },
      {
        id: '58',
        title: 'Mercure Jakarta Pantai Indah Kapuk - Diskon 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/mercure-jakarta-pantai-indah-kapuk',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pik-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pik-logo',
      },
      {
        id: '59',
        title: 'The Ritz-Carlton Jakarta, Mega Kuningan - Hemat 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/the-ritz-carlton-jakarta-mega-kuningan',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ritz-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ritz-logo',
      },
      {
        id: '60',
        title: 'The Ritz-Carlton Jakarta, Pacific Place - Hemat Hingga 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/the-ritz-carlton-jakarta-pacific-place',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ritz2-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ritz2-logo',
      },
      {
        id: '61',
        title: 'Raffles Jakarta - Hemat Hingga 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/raffles-jakarta',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/raffles-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/raffles-logo',
      },
      {
        id: '62',
        title: 'Sheraton Grand Jakarta Gandaria City - Diskon 30%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/sheraton-grand-jakarta-gandaria-city',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sheraton-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sheraton-logo',
      },
      {
        id: '63',
        title: 'Hotel Indonesia Kempinski Jakarta - Buy 4 Get Additional 2',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/hotel-indonesia-kempinski-jakarta',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hi-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hi-logo',
      },
      {
        id: '64',
        title: 'The Hermitage, a Tribute Portofolio Hotel, Jakarta - Hemat 10%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/the-hermitage-a-tribute-portofolio-hotel-jakarta',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hermitage-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hermitage-logo',
      },
      {
        id: '65',
        title: 'InterContinental Jakarta Pondok Indah - Penawaran Spesial',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/intercontinental-jakarta-pondok-indah',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/inter-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/inter-logo',
      },
      {
        id: '66',
        title: 'Hotel Gran Mahakam - Hemat Hingga 25%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/hotel-gran-mahakam',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/granmahakam-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/granmahakam-logo',
      },
      {
        id: '67',
        title: 'Padma Hotel Semarang - Cashback Rp 200.000',
        category: 'Hotel & Dining',
        city: 'Semarang',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/padma-hotel-semarang',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/padma-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/padma-logo',
      },
      {
        id: '68',
        title: 'Tokopedia - Potongan Harga hingga 388.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 24 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/tokopedia',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/tokopedia-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/tokopedia-logo',
      },
      {
        id: '69',
        title: 'Klik Indomaret - Potongan Harga',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/klik-indomaret',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/klikindomaret-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/klikindomaret-logo',
      },
      {
        id: '70',
        title: 'Blibli - Potongan & Cashback hingga 10%',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 24 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/blibli',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/blibli-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/blibli-logo',
      },
      {
        id: '71',
        title: 'Grab - Potongan hingga Rp 50.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/grab',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/grab-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/grab-logo',
      },
      {
        id: '72',
        title: 'Gopay - Double Cashback 8.8 + 18.8',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 28 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/gopay',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/gopay-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/gopay-logo',
      },
      {
        id: '73',
        title: 'DANA - Dapatkan Voucher Diskon 18.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 28 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/dana',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dana-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dana-logo',
      },
      {
        id: '74',
        title: 'Shopee -  Potongan Harga hingga Rp 118.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 25 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/shopee',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/shopee-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/shopee-logo',
      },
      {
        id: '75',
        title: 'ShopeePay - Dapatkan Cashback Rp 18.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 25 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/shopeepay',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/spay-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/spay-logo',
      },
      {
        id: '76',
        title: 'Alfagift - Diskon Rp 25.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 27 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/alfagift',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/alfagift-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/alfagift-logo',
      },
      {
        id: '77',
        title: 'Sayurbox - Diskon Rp 25.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 27 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/sayurbox',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sayurbox-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sayurbox-logo',
      },
      {
        id: '78',
        title: 'SCOOP - Diskon 10%',
        category: 'Home Appliance',
        city: 'Nasional',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/scoop',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/scoop-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/scoop-logo',
      },
      {
        id: '79',
        title: 'Electronic City - Angpau hingga Rp 1 Juta',
        category: 'Home Appliance',
        city: 'Nasional',
        periode: 'Hingga 26 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/electronic-city',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/eci-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/eci-logo',
      },
      {
        id: '80',
        title: 'eci.id - Angpau hingga Rp 1 Juta',
        category: 'Home Appliance',
        city: 'Nasional',
        periode: 'Hingga 26 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/eci-id',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/eci2-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/eci2-logo',
      },
      {
        id: '81',
        title: 'Mirror Beauty Bar Batam - Diskon 15%',
        category: 'Beauty',
        city: 'Batam',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/mirror-beauty-bar',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/mirror-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/mirror-logo',
      },
      {
        id: '82',
        title: 'May May Salon - Potongan Rp 88.000',
        category: 'Beauty',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/may-may-salon',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/maymay-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/maymay-logo',
      },
      {
        id: '83',
        title: 'Irwan Team Salon - Potongan Rp 88.000',
        category: 'Beauty',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/irwan-team-salon',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/irwan-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/irwan-logo',
      },
      {
        id: '84',
        title: 'Haircode Salon - Diskon 10%',
        category: 'Beauty',
        city: 'Nasional',
        periode: 'Hingga 20 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/haircode-salon',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/haircode-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/haircode-logo',
      },
      {
        id: '85',
        title: 'Anna Wijaya Salon - Dapatkan Lucky Ang Pao',
        category: 'Beauty',
        city: 'Nasional',
        periode: 'Hingga 20 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/anna-wijaya-salon',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/anna-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/anna-logo',
      },
      {
        id: '86',
        title: 'Chillax - Voucher Belanja Rp 100.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/chillax',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chillax-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chillax-logo',
      },
      {
        id: '87',
        title: 'Old Shanghai - Dapatkan Voucher Rp 50.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/old-shanghai',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/old-shanghai-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/old-shanghai-logo',
      },
      {
        id: '88',
        title: 'MTIX - Penawaran Spesial',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 31 Maret 2023',
        link: 'https://www.bca.co.id/Campaign/promo-imlek/2022/12/29/01/59/mtix',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/mtix-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/mtix-logo',
      },
      {
        id: '89',
        title: 'Sociolla - Diskon Rp 88.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 26 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/sociolla',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sociolla-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sociolla-logo',
      },
      {
        id: '90',
        title: 'Zalora - Diskon 15%',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/zalora',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/zalora-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/zalora-logo',
      },
    ],
    en: [
      {
        id: '1',
        title: 'Yogya Group Bandung - Free Voucher Rp 100.000',
        category: 'Groceries',
        city: 'Bandung',
        periode: 'Hingga 24 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/yogya-group',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/yogya-group-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/yogya-group-logo',
      },
      {
        id: '2',
        title: 'JC SUPERMARKET BCS Batam - Dapatkan Voucher Rp 50.000',
        category: 'Groceries',
        city: 'Batam',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/jc-supermarket-bcs',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jc-supermarket-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jc-supermarket-logo',
      },
      {
        id: '3',
        title: 'JM Group Palembang - Dapatkan Hadiah Langsung Minyak Goreng 2 Liter',
        category: 'Groceries',
        city: 'Palembang',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/jm-group',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jm-group-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jm-group-logo',
      },
      {
        id: '4',
        title: 'Brastagi Supermarket Medan - Dapatkan 1 Pack Jeruk',
        category: 'Groceries',
        city: 'Medan',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/brastagi-supermarket',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/brastagi-supermarket-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/brastagi-supermarket-logo',
      },
      {
        id: '5',
        title: 'Rezeki Supermarket - Free Voucher Rp 25.000',
        category: 'Groceries',
        city: 'Jabodetabek',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/rezeki-supermarket',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/rezeki-supermarket-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/rezeki-supermarket-logo',
      },
      {
        id: '6',
        title: 'Market City - Free Voucher Rp 25.000',
        category: 'Groceries',
        city: 'Jabodetabek',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/market-city',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/market-city-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/market-city-logo',
      },
      {
        id: '7',
        title: 'GS Retail - Dapatkan Free Product',
        category: 'Groceries',
        city: 'Jabodetabek',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/gs-retail',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/retail-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/retail-logo',
      },
      {
        id: '8',
        title: 'Papaya Fresh Gallery Bali - Dapatkan Voucher Rp 50.000',
        category: 'Groceries',
        city: 'Bali',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/papaya-fresh-gallery',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pepaya-fresh-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pepaya-fresh-logo',
      },
      {
        id: '9',
        title: 'Istana Buah Semarang - Hadiah Beras Organik',
        category: 'Groceries',
        city: 'Semarang',
        periode: 'Hingga 16 Juni 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/istana-buah',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/istana-buah-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/istana-buah-logo',
      },
      {
        id: '10',
        title: 'Ranch Market - Dapatkan Voucher hingga Rp 150.000',
        category: 'Groceries',
        city: 'Nasional',
        periode: 'Hingga 16 Juni 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/ranch-market',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ranch-market-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ranch-market-logo',
      },
      {
        id: '11',
        title: 'The Foodhall - Dapatkan Voucher hingga Rp 100.000',
        category: 'Groceries',
        city: 'Nasional',
        periode: 'Hingga 31 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/foodhall',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/foodhall-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/foodhall-logo',
      },
      {
        id: '12',
        title: 'All Fresh - Redeem Reward BCA Rp 88.000, Gratis Jeruk 1 Pack',
        category: 'Reward BCA',
        city: 'Nasional',
        periode: 'Hingga 23 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/all-fresh',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/allfresh-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/allfresh-logo',
      },
      {
        id: '13',
        title: 'Ranch Market Group - Redeem Reward BCA Rp 88.000, Gratis Jeruk 1 Pack',
        category: 'Reward BCA',
        city: 'Nasional',
        periode: 'Hingga 23 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/ranch-market',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ranch-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ranch-logo',
      },
      {
        id: '14',
        title: 'The FoodHall & Daily FoodHall - Redeem Reward BCA Rp 88.000, Gratis Jeruk 1 Pack',
        category: 'Reward BCA',
        city: 'Nasional',
        periode: 'Hingga 23 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/the-foodhall',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/foodhall-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/foodhall-logo',
      },
      {
        id: '15',
        title: '5th Avenue Semarang - Dapatkan Cake',
        category: 'Food & Beverage',
        city: 'Semarang',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/5th-avenue',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/avenue-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/avenue-logo',
      },
      {
        id: '16',
        title: 'Angke Restaurant - Potongan harga Rp 288.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/angke-restaurant',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/angke-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/angke-logo',
      },
      {
        id: '17',
        title: 'Bali Sentosa Seafood - Potongan Langsung Rp 88.000',
        category: 'Food & Beverage',
        city: 'Kuta',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/bali-sentosa-seafood',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sentosa-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sentosa-logo',
      },
      {
        id: '18',
        title: 'Ban Ban - Diskon 25%',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 10 April 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/ban-ban',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/banban-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/banban-logo',
      },
      {
        id: '19',
        title: 'Chopstix - Potongan Rp 20.000',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 10 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/chopstix',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chopstix-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chopstix-logo',
      },
      {
        id: '20',
        title: 'DIMSUM INS Solo - Dapatkan Ekstra Dimsum',
        category: 'Food & Beverage',
        city: 'Solo',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/dimsum-ins',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dimsum-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dimsum-logo',
      },
      {
        id: '21',
        title: 'Dragon Hot Pot - Dapatkan Potongan Rp 50.000 & Liang Teh/ Grass Jelly',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/dragon-hot-pot',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dragon-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dragon-logo',
      },
      {
        id: '22',
        title: 'Duck King - Potongan Hingga Rp 1 Juta',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/duck-king',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/duckking-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/duckking-logo',
      },
      {
        id: '23',
        title: 'Gong cha - Lucky Dip',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/gong-cha',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/gongcha-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/gongcha-logo',
      },
      {
        id: '24',
        title: 'Han Palace Surabaya - Potongan Rp 200.000',
        category: 'Food & Beverage',
        city: 'Surabaya',
        periode: 'Hingga 20 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/han-palace',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/han-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/han-logo',
      },
      {
        id: '25',
        title: 'Ikkudo - Potongan Rp 20.000',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 31 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/ikkudo',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ikkudo-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ikkudo-logo',
      },
      {
        id: '26',
        title: 'Jumbo Restoran Medan - Diskon 50% Menu Pilihan',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/jumbo-restoran',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jsr-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jsr-logo',
      },
      {
        id: '27',
        title: 'Kwetiau Aho 88 - Potongan Rp 10.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/kwetiau-aho-88',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/kwetiau-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/kwetiau-logo',
      },
      {
        id: '28',
        title: 'May Star Surabaya - Potongan Hingga Rp 1.188.000',
        category: 'Food & Beverage',
        city: 'Surabaya',
        periode: 'Hingga 31 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/may-star',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/avenue-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/avenue-logo',
      },
      {
        id: '29',
        title: 'New Fajar Restaurant Surabaya - Potongan Harga Rp 200.000',
        category: 'Food & Beverage',
        city: 'Surabaya',
        periode: 'Hingga 20 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/new-fajar-restaurant',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/fajar-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/fajar-logo',
      },
      {
        id: '30',
        title: 'Ocean 8 - Potongan Rp 288.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/ocean-8',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ocean-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ocean-logo',
      },
      {
        id: '31',
        title: 'Paradise Dynasty - Potongan Rp 288.000',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/paradise-dynasty',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dynasty-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dynasty-logo',
      },
      {
        id: '32',
        title: 'Pilastro Signature Medan - Dapatkan Kertas Angpao',
        category: 'Food & Beverage',
        city: 'Medan',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/pilastro-signature',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pilastro-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pilastro-logo',
      },
      {
        id: '33',
        title: 'Raa Cha - Potongan Rp 20.000',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 10 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/raa-cha',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/reacha-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/reacha-logo',
      },
      {
        id: '34',
        title: 'RM Hongkong Makassar - Diskon 20%',
        category: 'Food & Beverage',
        city: 'Makassar',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/40/rm-hongkong',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hongkong-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hongkong-logo',
      },
      {
        id: '35',
        title: 'Royal Dynasty Restaurant Bandung - Cashback Rp 100.000',
        category: 'Food & Beverage',
        city: 'Bandung',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/royal-dynasty-restaurant',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/royal-dynasty-1-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/royal-dynasty-1-logo',
      },
      {
        id: '36',
        title: 'Royal Resto Group Surabaya - Potongan Hingga Rp 200.000',
        category: 'Food & Beverage',
        city: 'Surabaya',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/royal-resto-group',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/royal-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/royal-logo',
      },
      {
        id: '37',
        title: 'Sari Laut Musi Palembang - Potongan Rp 100.000',
        category: 'Food & Beverage',
        city: 'Palembang',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/sari-laut-musi',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/slm-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/slm-logo',
      },
      {
        id: '38',
        title: 'Shu Guo Yin Xiang Bandung - Potongan Rp 150.000',
        category: 'Food & Beverage',
        city: 'Bandung',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/shu-guo-yin-xiang',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sgyx-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sgyx-logo',
      },
      {
        id: '39',
        title: 'The Grill Estate Batam - Diskon 20%',
        category: 'Food & Beverage',
        city: 'Batam',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/the-grill-estate',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/grill-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/grill-logo',
      },
      {
        id: '40',
        title: 'The Leaf BSD - Potongan Hingga Rp 1 Juta',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/the-leaf-bsd',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/leaf-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/leaf-logo',
      },
      {
        id: '41',
        title: 'Warung Laota Makassar - Diskon 20%',
        category: 'Food & Beverage',
        city: 'Makassar',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/warung-laota',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/laota-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/laota-logo',
      },
      {
        id: '42',
        title: 'Wee Nam Kee - Harga Spesial Paket Makan',
        category: 'Food & Beverage',
        city: 'Nasional',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/wee-nam-kee',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/wnk-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/wnk-logo',
      },
      {
        id: '43',
        title: 'Wong Fu Kie - Potongan Hingga 288.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/28/00/53/wong-fu-kie',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/wfk-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/wfk-logo',
      },
      {
        id: '44',
        title: 'H&M - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/hnm',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hnm-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hnm-logo',
      },
      {
        id: '45',
        title: 'Hush Puppies - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/hush-puppies',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hush-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hush-logo',
      },
      {
        id: '46',
        title: 'Obermain - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/obermain',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/obermain-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/obermain-logo',
      },
      {
        id: '47',
        title: 'CAT - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/cat',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/cat-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/cat-logo',
      },
      {
        id: '48',
        title: 'Playboy/ 101 Shoes - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/playboy',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/playboy-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/playboy-logo',
      },
      {
        id: '49',
        title: 'Le Sportsac - Potongan Rp 88.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/le-sportsac',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/lesport-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/lesport-logo',
      },
      {
        id: '50',
        title: 'Central Dept. Store - Dapatkan Voucher Shopping Rp 100 Ribu dan Grand Prize Voucher Rp 888 Ribu',
        category: 'Fashion',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/central-dept-store',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/central-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/central-logo',
      },
      {
        id: '51',
        title: 'This is April - Diskon 10%',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/this-is-april',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/april-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/april-logo',
      },
      {
        id: '52',
        title: 'Urban Icon - Potongan Rp 188 Ribu',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/urban-icon',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/urban-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/urban-logo',
      },
      {
        id: '53',
        title: 'Fossil - Potongan Rp 288.000',
        category: 'Fashion',
        city: 'Nasional',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/00/28/fossil',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/fossil-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/fossil-logo',
      },
      {
        id: '54',
        title: 'The Arista Hotel Palembang - Diskon 20%',
        category: 'Hotel & Dining',
        city: 'Palembang',
        periode: 'Hingga 21 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/the-arista-hotel',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/arista-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/arista-logo',
      },
      {
        id: '55',
        title: 'Ching San Restaurant (Melia Purosani Hotel Yogyakarta) - Buy 10 Get 1 Free',
        category: 'Hotel & Dining',
        city: 'Yogyakarta',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/ching-san-restaurant-melia-purosani-hotel',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chingsan-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chingsan-logo',
      },
      {
        id: '56',
        title: 'Swissotel Jakarta PIK Avenue - Diskon 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/swissotel-jakarta-pik-avenue',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/swiss-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/swiss-logo',
      },
      {
        id: '57',
        title: 'JW Marriott Jakarta - Hemat 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/jw-marriott-jakarta',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jw-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/jw-logo',
      },
      {
        id: '58',
        title: 'Mercure Jakarta Pantai Indah Kapuk - Diskon 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/mercure-jakarta-pantai-indah-kapuk',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pik-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/pik-logo',
      },
      {
        id: '59',
        title: 'The Ritz-Carlton Jakarta, Mega Kuningan - Hemat 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/the-ritz-carlton-jakarta-mega-kuningan',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ritz-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ritz-logo',
      },
      {
        id: '60',
        title: 'The Ritz-Carlton Jakarta, Pacific Place - Hemat Hingga 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/the-ritz-carlton-jakarta-pacific-place',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ritz2-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/ritz2-logo',
      },
      {
        id: '61',
        title: 'Raffles Jakarta - Hemat Hingga 20%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/raffles-jakarta',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/raffles-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/raffles-logo',
      },
      {
        id: '62',
        title: 'Sheraton Grand Jakarta Gandaria City - Diskon 30%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/sheraton-grand-jakarta-gandaria-city',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sheraton-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sheraton-logo',
      },
      {
        id: '63',
        title: 'Hotel Indonesia Kempinski Jakarta - Buy 4 Get Additional 2',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/hotel-indonesia-kempinski-jakarta',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hi-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hi-logo',
      },
      {
        id: '64',
        title: 'The Hermitage, a Tribute Portofolio Hotel, Jakarta - Hemat 10%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/the-hermitage-a-tribute-portofolio-hotel-jakarta',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hermitage-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/hermitage-logo',
      },
      {
        id: '65',
        title: 'InterContinental Jakarta Pondok Indah - Penawaran Spesial',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/intercontinental-jakarta-pondok-indah',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/inter-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/inter-logo',
      },
      {
        id: '66',
        title: 'Hotel Gran Mahakam - Hemat Hingga 25%',
        category: 'Hotel & Dining',
        city: 'Jabodetabek',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/02/52/hotel-gran-mahakam',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/granmahakam-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/granmahakam-logo',
      },
      {
        id: '67',
        title: 'Padma Hotel Semarang - Cashback Rp 200.000',
        category: 'Hotel & Dining',
        city: 'Semarang',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/padma-hotel-semarang',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/padma-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/padma-logo',
      },
      {
        id: '68',
        title: 'Tokopedia - Potongan Harga hingga 388.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 24 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/tokopedia',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/tokopedia-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/tokopedia-logo',
      },
      {
        id: '69',
        title: 'Klik Indomaret - Potongan Harga',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/klik-indomaret',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/klikindomaret-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/klikindomaret-logo',
      },
      {
        id: '70',
        title: 'Blibli - Potongan & Cashback hingga 10%',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 24 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/blibli',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/blibli-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/blibli-logo',
      },
      {
        id: '71',
        title: 'Grab - Potongan hingga Rp 50.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/grab',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/grab-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/grab-logo',
      },
      {
        id: '72',
        title: 'Gopay - Double Cashback 8.8 + 18.8',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 28 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/gopay',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/gopay-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/gopay-logo',
      },
      {
        id: '73',
        title: 'DANA - Dapatkan Voucher Diskon 18.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 28 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/dana',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dana-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/dana-logo',
      },
      {
        id: '74',
        title: 'Shopee -  Potongan Harga hingga Rp 118.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 25 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/shopee',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/shopee-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/shopee-logo',
      },
      {
        id: '75',
        title: 'ShopeePay - Dapatkan Cashback Rp 18.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 25 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/shopeepay',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/spay-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/spay-logo',
      },
      {
        id: '76',
        title: 'Alfagift - Diskon Rp 25.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 27 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/alfagift',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/alfagift-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/alfagift-logo',
      },
      {
        id: '77',
        title: 'Sayurbox - Diskon Rp 25.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 27 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/sayurbox',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sayurbox-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sayurbox-logo',
      },
      {
        id: '78',
        title: 'SCOOP - Diskon 10%',
        category: 'Home Appliance',
        city: 'Nasional',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/scoop',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/scoop-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/scoop-logo',
      },
      {
        id: '79',
        title: 'Electronic City - Angpau hingga Rp 1 Juta',
        category: 'Home Appliance',
        city: 'Nasional',
        periode: 'Hingga 26 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/electronic-city',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/eci-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/eci-logo',
      },
      {
        id: '80',
        title: 'eci.id - Angpau hingga Rp 1 Juta',
        category: 'Home Appliance',
        city: 'Nasional',
        periode: 'Hingga 26 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/27/08/08/eci-id',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/eci2-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/eci2-logo',
      },
      {
        id: '81',
        title: 'Mirror Beauty Bar Batam - Diskon 15%',
        category: 'Beauty',
        city: 'Batam',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/mirror-beauty-bar',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/mirror-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/mirror-logo',
      },
      {
        id: '82',
        title: 'May May Salon - Potongan Rp 88.000',
        category: 'Beauty',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/may-may-salon',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/maymay-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/maymay-logo',
      },
      {
        id: '83',
        title: 'Irwan Team Salon - Potongan Rp 88.000',
        category: 'Beauty',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/irwan-team-salon',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/irwan-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/irwan-logo',
      },
      {
        id: '84',
        title: 'Haircode Salon - Diskon 10%',
        category: 'Beauty',
        city: 'Nasional',
        periode: 'Hingga 20 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/haircode-salon',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/haircode-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/haircode-logo',
      },
      {
        id: '85',
        title: 'Anna Wijaya Salon - Dapatkan Lucky Ang Pao',
        category: 'Beauty',
        city: 'Nasional',
        periode: 'Hingga 20 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/anna-wijaya-salon',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/anna-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/anna-logo',
      },
      {
        id: '86',
        title: 'Chillax - Voucher Belanja Rp 100.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 29 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/chillax',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chillax-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/chillax-logo',
      },
      {
        id: '87',
        title: 'Old Shanghai - Dapatkan Voucher Rp 50.000',
        category: 'Food & Beverage',
        city: 'Jabodetabek',
        periode: 'Hingga 5 Februari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/old-shanghai',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/old-shanghai-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/old-shanghai-logo',
      },
      {
        id: '88',
        title: 'MTIX - Penawaran Spesial',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 31 Maret 2023',
        link: 'https://www.bca.co.id/Campaign/promo-imlek/2022/12/29/01/59/mtix',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/mtix-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/mtix-logo',
      },
      {
        id: '89',
        title: 'Sociolla - Diskon Rp 88.000',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 26 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/sociolla',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sociolla-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/sociolla-logo',
      },
      {
        id: '90',
        title: 'Zalora - Diskon 15%',
        category: 'e-Commerce',
        city: 'Nasional',
        periode: 'Hingga 22 Januari 2023',
        link: 'https://www.bca.co.id/id/Campaign/promo-imlek/2022/12/29/01/59/zalora',
        thumbnail: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/zalora-thu',
        logo: 'https://www.bca.co.id/-/media/Images/campaign/2022/imlek/zalora-logo',
      },
    ],
  },
};
